import { useState, useEffect } from 'react';

export const useAlpineStore = (storeName) => {
    const [store, setStore] = useState(null);

    useEffect(() => {
        const getAlpineStore = () => {
            if (window.Alpine && window.Alpine.store) {
                const alpineStore = window.Alpine.store(storeName);
                if (alpineStore) {
                    setStore(alpineStore);
                }
            }
        };

        // Call the function initially to set the store
        getAlpineStore();

        // Optional: Add event listener to update store when Alpine is ready
        document.addEventListener('alpine:init', getAlpineStore);

        // Cleanup event listener on component unmount
        return () => {
            document.removeEventListener('alpine:init', getAlpineStore);
        };
    }, [storeName]);

    return store;
};